import { paths, routes } from 'pages/booking/routes';
import lazyWithRetry from 'services/lazyWithRetry';
import selectors from 'store/booking/selectors';
import { actions } from 'store/booking/slice';
import { BookingApiItem } from 'typings/api';
import { Resource } from 'typings/shared';
import api from './api';

const resource: Resource<BookingApiItem, typeof paths, typeof api, typeof actions, typeof selectors, typeof routes> = {
    name: 'booking',
    translationKey: 'booking',
    api,
    selectors,
    paths,
    routes,
    actions,
    component: lazyWithRetry(() => import('pages/booking')),
};

export default resource;
